import { Chat } from '@/types/api/types'
import Repository from './repository'

export default {
  getChats() {
    return Repository.get<{ chats: Chat[] }>(`/v2/user/chats`)
  },
  getChat({ chatId }) {
    return Repository.get<Chat>(`/v2/user/chats/${chatId}`)
  },
  postMessage({ chatId, content }) {
    return Repository.post(`/v1/user/chats/${chatId}/messages`, {
      message: { content },
    })
  },
}
